import { EColors } from "common/styles";
import { FLEX, FONT } from "common/utils";
import styled from "styled-components";

export const ButtonText = styled.span`
  ${FLEX({ align: "center" })};
  font-family: "Fira Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: ${EColors.white};
  transition: all 0.3s linear;
`;

export const StyledButton = styled.button<{
  width: string;
  height: string;
}>`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  outline: none;
  border: 1px solid transparent;
  border-radius: 60px;
  padding: 17.5px 10px;
  white-space: nowrap;
  box-sizing: border-box;
  outline: none;
  flex-shrink: 1;
  order: 1;
  align-self: stretch;
  background: ${EColors.accent_300};
  transition: all 0.2s linear;
  cursor: pointer;
  &:hover {
    background: ${EColors.accent_200};
  };
  &:focus{
    background: ${EColors.accent_400};
  }
  
  @media screen and (max-width: 449px) {
    width:100%;
  }
`;
